import { Box, Typography, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { theme } from '../../App'
import { ReactComponent as AppSvg } from "./appstore.svg";
import { ReactComponent as GoogleSvg } from "./google_play.svg";
import { Motion } from '../Motion/Motion';
import { Link } from 'react-router-dom';
import { LogAnalytics } from '../../Classes/firebase';


export default function DownloadLine({ appPageData, bgcolor = "transparent" }) {
    const [logged, setLogged] = useState(false);
    const mobile = useMediaQuery(theme.breakpoints.down('md'));

    const Appstore = () => {
        const editedIcon = React.cloneElement(<AppSvg />, {
            style: {
                maxHeight: "44px",
                maxWidth: "154px",
            },
        });
        return <>{editedIcon}</>;
    };

    const Google = () => {
        const editedIcon = React.cloneElement(<GoogleSvg />, {
            style: {
                maxHeight: "44px",
                maxWidth: "154px",
            },
        });
        return <>{editedIcon}</>;
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', py: { xs: '40px', sm: '40px', md: '60px' }, bgcolor }}>
            {!mobile && <Typography variant='big' sx={{ mr: '50px' }}>Stáhnout</Typography>}
            <Box sx={{ pr: '40px' }}>
                <Motion>
                    <Box sx={{
                        cursor: 'pointer',
                        display: 'flex', alignItems: 'center', alignContent: 'center'
                    }} >
                        <Link style={{ height: '40px' }} to={appPageData.googleLink} target='blank' onClick={() => {
                            if (logged) return;
                            LogAnalytics("click_download", { platform: 'google', link: appPageData.link });
                            setLogged(true);
                        }}><Google /></Link>
                    </Box>
                </Motion>
            </Box>
            <Motion>
                <Box sx={{
                    cursor: 'pointer',
                    display: 'flex', alignItems: 'center', alignContent: 'center'

                }}>
                    <Link style={{ height: '40px' }} to={appPageData.appstoreLink} target='blank' onClick={() => {
                        if (logged) return;
                        LogAnalytics("click_download", { platform: 'apple', link: appPageData.link });
                        setLogged(true);
                    }}><Appstore /></Link>
                </Box>
            </Motion>
        </Box>
    )
}
